import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CSearchToggleBookmarkIconButton } from '@/components/modules/pages/consultantSearch/Button/CSearchToggleBookmarkIconButton';
import { propFunc, propShape } from '../../../helpers/custom-prop-types';
const SlideModeFavoriteComponent = (props) => {
    const { item, onClickSlideClip, slideFavoriteMap } = props;
    if (!item) {
        return null;
    }
    const { item: { hasFavorite, id }, } = item;
    return (_jsx("div", Object.assign({ className: 'slide-item-slide-favorite-element' }, { children: _jsx("div", { children: _jsx(CSearchToggleBookmarkIconButton, { boolState: slideFavoriteMap[id] === undefined
                    ? hasFavorite
                    : slideFavoriteMap[id], isFalseIconColorWhite: true, onClick: onClickSlideClip, size: 'lg', value: id }) }) })));
};
SlideModeFavoriteComponent.propTypes = {
    item: propShape(),
    onClickSlideClip: propFunc().isRequired,
    slideFavoriteMap: propShape().isRequired,
};
SlideModeFavoriteComponent.defaultProps = {
    item: undefined,
};
export default SlideModeFavoriteComponent;
